import React from "react";
import { ModalWithIcon } from "@scripts/react/components/RfModal/ModalWithIcon";

interface UnknownModalProps {
    isOpen: boolean;
    onClose: () => void;
    modalType: string;
}

export const UnknownModal: React.FC<UnknownModalProps> = ({ isOpen, onClose, modalType }) => {
    return (
        <ModalWithIcon
            isOpen={isOpen}
            onClose={onClose}
            onSubmit={onClose}
            type="warning"
            size="md"
            icon="far fa-question-circle"
            title="Page Not Found"
            submitButtonText="Got It"
            submitButtonProps={{ type: "secondary" }}
            className="text-center"
        >
            <p>The page you're looking for doesn't exist or may have been moved.</p>
            <p className="text-sm text-tertiary">
                If you followed a link, it may be outdated. Please check the URL or contact support
                if you believe this is an error.
            </p>
        </ModalWithIcon>
    );
};
